globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Modules = appCustomerSpace.Modules || {};

appCustomerSpace.Modules.InputClearable = (function() {

  function InputClearable($input) {
    this.$input = $input;
    this.$formGroup = this.$input.closest('.form-group');
    this.$form = this.$formGroup.closest('form');
    this.$clear = this.$formGroup.find('.form-control-feedback');
    this.init();
  }

  InputClearable.init = function($html) {
    $html.find('input.allow-clear').each(function(){
      new InputClearable($(this));
    })
  }

  InputClearable.prototype = {
    init: function() {
      var _this = this;

      _this.displayClearButton();

      _this.$clear.on('click', function(){
        _this.$input.val('').keyup().change();
        _this.$form.submit();
      });

      _this.$input.on('change keyup', function(){
        _this.displayClearButton();
      });
    },
    displayClearButton: function(){
      if(this.$input.val().length > 0) {
        this.$clear.show();
      } else {
        this.$clear.hide();
      }
    }
  }

  return InputClearable;

})();
